/**
 * List of account emails allowed to access the Family Museum page.
 * Only these members can view and use the page. Update or replace with
 * an API/backend check if you prefer server-side member list.
 */
const ADMIN_EMAIL = 'jifuzhou90@gmail.com';

const envEmails = (typeof process !== 'undefined' && process.env?.REACT_APP_FAMILY_MUSEUM_MEMBERS)
  ? process.env.REACT_APP_FAMILY_MUSEUM_MEMBERS.split(',').map((e) => e.trim().toLowerCase())
  : [];

export const FAMILY_MUSEUM_ALLOWED_EMAILS = [
  ADMIN_EMAIL.toLowerCase(),
  ...envEmails.filter((e) => e && e !== ADMIN_EMAIL.toLowerCase()),
];

export function isFamilyMuseumMember(email) {
  if (!email) return false;
  return FAMILY_MUSEUM_ALLOWED_EMAILS.includes(String(email).trim().toLowerCase());
}
